/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Weight_UnitInputs */

const en_us2_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight unit`)
};

const pt_br2_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidade de peso`)
};

const es_419_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidad de peso`)
};

const pt_pt2_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidade de peso`)
};

const fr_fr2_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unité de poids`)
};

const de_de2_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewichtseinheit`)
};

const it_it2_profile_weight_unit = /** @type {(inputs: Profile_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unità di peso`)
};

/**
* | output |
* | --- |
* | "Weight unit" |
*
* @param {Profile_Weight_UnitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_unit = /** @type {((inputs?: Profile_Weight_UnitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_UnitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_unit(inputs)
	if (locale === "es-419") return es_419_profile_weight_unit(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_unit(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_unit(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_unit(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_unit(inputs)
	return en_us2_profile_weight_unit(inputs)
});
export { profile_weight_unit as "profile.weight_unit" }